import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { leftMainMenu } from 'src/app/core/menu/leftMainMenuList';
import { DataService } from '../../common-services/data.service';
import { SharedService } from '../../common-services/shared.service';
import { HeaderService } from '../header/header-service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  isMenuShown: boolean = false;
  disableMenu: boolean = false;
  leftMainMenuList: any[] = [...leftMainMenu.menu];
  selectedModule: any;

  constructor(
    public _toggleButton: HeaderService,
    public _router: Router,
    public _sharedService: SharedService,
    private _dataService: DataService
  ) {
    this.leftMainMenuList = leftMainMenu.menu.filter((elem: any) =>
      this._sharedService.rbacManagement(elem?.privilege)
    );
    const moduleIndex = this.findNavigationIndex();
    if (moduleIndex === -1 && this.leftMainMenuList.length) {
      this.selectedModule = this.leftMainMenuList[0];
      this.menuChange(this.selectedModule.nav);
    } else if (moduleIndex >= 0) {
      this.menuChange(this.leftMainMenuList[moduleIndex].nav);
    }

    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const newModuleIndex = this.findNavigationIndex();
        if (newModuleIndex > -1) {
          this.selectedModule = this.leftMainMenuList.find(
            (data: any) => data.nav === this.leftMainMenuList[newModuleIndex].nav
          );
          this._sharedService.setTitle(this.selectedModule?.name);
        }
      }
    });
    this._toggleButton.getToggleButtonClick().subscribe(() => {
      this.isMenuShown = !this.isMenuShown;
    });
  }

  findNavigationIndex() {
    const urlSplits = this._router.url.split('/');
    const moduleNav = urlSplits[1] ? urlSplits[1] : null;
    const moduleIndex = this.leftMainMenuList.findIndex((item: any) => item.nav === moduleNav);
    return moduleIndex;
  }

  menuChange(moduleNav: string) {
    this.selectedModule = this.leftMainMenuList.find((data: any) => data.nav === moduleNav);
    this._sharedService.setTitle(this.selectedModule?.name);
    this._dataService?.broadcast('menuChange', this.selectedModule?.nav);
  }
}
